import get from 'get-value';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import 'react-table/react-table.css';
import { fetchInternalAseSearch } from '../../../actions/ase/actionAseInternalTicketSearch';
import { editAseInternalTicketListButtonVisibility } from '../../../constants/aseInternalTicketRights';
import { ASE_INTERNAL_MAINTENANCE_TICKET_FORM, ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET_FORM, ASE_INTERNAL_TICKET_FORM } from '../../../constants/formConstants';
import { domains } from '../../../constants/Utils';
import internalFulltextSearchMessages from '../../../intl/afterSales/internalFulltextSearchMessages';
import { ASE_INTERNAL_MAINTENANCE_TICKET, ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET, ASE_INTERNAL_TICKET } from '../../../routes/paths';
import { moduleRoles } from '../../../utils/roles';
import { IconEdit, PrimaryIcon } from '../../common/Button';
import Table from '../../common/table/TicketTable';


class InternalTicketSearchAseTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listDefaultPageSize: 10,
            listDefaultSort: [{id: 'ticketNumber', desc: true}],
        };
        this.handleFetchData = this.handleFetchData.bind(this);
    }

    handleFetchData(tableData) {
        this.props.fetchInternalAseSearch(
            tableData.pageSize,
            tableData.sorted,
            tableData.cursor,
            tableData.isNextFromPivot,
            get(this.props, 'listDefaultFilters.1', {default: {}}),
            get(this.props, 'listDefaultFilters.0', {default: []})
        );
        this.setState({
            listDefaultPageSize: tableData.pageSize,
            listDefaultSort: tableData.sorted,
        });
    }

    render() {
        const {columns = [], handleEditClick, listDefaultFilters, roles, searchData} = this.props;
        const {fullTextData, isLoading, isNextPage, isNextFromPivot, pages} = searchData;

        const formTypeToPathMap = {
            [ASE_INTERNAL_TICKET_FORM]: ASE_INTERNAL_TICKET,
            [ASE_INTERNAL_MAINTENANCE_TICKET_FORM]: ASE_INTERNAL_MAINTENANCE_TICKET,
            [ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET_FORM]: ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET,
        };

        return (
            <div className="container-fluid text-center">
                <div className="row">
                    <div className="col">
                        <Table
                            columns={[
                                {
                                    id: 'ticketNumber',
                                    accessor: 'ticketNumber',
                                    filterable: false,
                                    message: internalFulltextSearchMessages.TABLE_TICKET_NUMBER,
                                    Cell: (row) => {
                                        const path = `${formTypeToPathMap[get(row, 'original.formType')] || ASE_INTERNAL_TICKET}/view/${row.original.id}`
                                        return <Link to={path}>{row.value}</Link>
                                    }
                                },
                                ...columns]}
                            toolButtons={[
                                {
                                    handleClick: handleEditClick,
                                    component: <PrimaryIcon className="btn btn-sm"
                                                            title="Edit"
                                                            type="button"
                                                            key="editButton">
                                        <IconEdit/>
                                    </PrimaryIcon>
                                }
                            ]}
                            isLoading={isLoading}
                            data={fullTextData}
                            pages={pages}
                            handleFetchData={this.handleFetchData}
                            isNextPage={isNextPage}
                            isNextFromPivot={isNextFromPivot}
                            defaultFiltered={listDefaultFilters}
                            defaultSorting={this.state.listDefaultSort}
                            defaultPageSize={this.state.listDefaultPageSize}
                            buttonVisibility={editAseInternalTicketListButtonVisibility['AS_SG_EDITOR']}
                            dealerNumber={moduleRoles.isDealerAse(this.props.userRoles) ? this.props.dealerNumber : 'EDITOR'}
                            editorGroups={moduleRoles.isEditorAse(this.props.userRoles) ? moduleRoles.getEditorGroups(domains.ASE, this.props.userRoles).map(e => e.group) : false}
                            sgPermissions = {get(roles, `${domains.ASE}.sgEditor.sgPermission`)}
                            toolSortable={true}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

InternalTicketSearchAseTable.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    isNextPage: PropTypes.bool.isRequired,
    isNextFromPivot: PropTypes.bool.isRequired,
    pages: PropTypes.number.isRequired,
    handleEditClick: PropTypes.func.isRequired,
    fetchAseFullTextSearchPageData: PropTypes.func.isRequired,
    columns: PropTypes.array.isRequired,
    listDefaultFilters: PropTypes.array.isRequired,
    userRoles: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    searchData: state.aseInternalTicketSearch,
    userRoles: state.profile.userDetail.roles,
    dealerNumber: state.profile.userDetail.dealerNumber,
    roles: state.profile.userDetail.roles,
});

export default connect(mapStateToProps, {fetchInternalAseSearch})(InternalTicketSearchAseTable);
